import {
  GET_LOCATIONLIST_DATA_ERROR,
  GET_LOCATIONLIST_DATA_LOADING,
  GET_LOCATIONLIST_DATA_SUCCESS,
} from "../../type/Constant";

let initialState = {
  loading: false,
  user: [],
  error: false,
  errors: [],
  success: false,
  pagination: {},
};

export default function getLocationListReducer(state = initialState, action) {
  switch (action.type) {
    case GET_LOCATIONLIST_DATA_LOADING:
      return { ...state, success: false, loading: true };

    case GET_LOCATIONLIST_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        user: action.payload,
        pagination: action.pagination,
      };

    case GET_LOCATIONLIST_DATA_ERROR:
      return { ...state, error: true, errors: action.errors };

    // case RESET_LOCATION_DATA:
    //   return {
    //     ...state,loading: false,error: false,errors: action.errors,success: false,
    //   };

    default:
      return state;
  }
}
